import { Link } from "react-router-dom"
import Sweetalert from "../utils/Sweetalert"
import API from "../utils/API"

export default function DisplayManageTableItem({ display, deleteDisplay }) {
  // Comportements
  const handleDelete = () => {
    Sweetalert.fireConfirm(
      "Êtes vous sur de vouloir supprimer cet emplacement ?",
      "",
      () => {
        API.DELETE("/admin/display/" + display.id, (response) => {
          Sweetalert.fireSuccessToast(response.data.message)
          deleteDisplay(display.id)
        })
      }
    )
  }

  // Rendu
  return (
    <tr>
      <td>
        <Link to={"/display/gestion/" + display.id}>{display.code || "-"}</Link>
      </td>
      <td>{display.agency || "-"}</td>
      <td>{display.address || "-"}</td>
      <td>
        {display.zip_code && `${display.zip_code} `}
        {display.city || "-"}
      </td>
      <td>
        <span className={`badge badge-${display.type === "Digital" ? "success" : "secondary"}`}>
          {display.type || "-"}
        </span>
      </td>
      <td>{display.format || "-"}</td>
      <td>{display.sector || "-"}</td>
      <td className="project-actions text-right">
        <Link to={"/display/gestion/" + display.id} className="btn btn-primary btn-xs mr-2">
          <i className="fas fa-folder"></i>
          <span className="ml-1">Gestion</span>
        </Link>
        <button className="btn btn-danger btn-xs" onClick={handleDelete}>
          <i className="fas fa-trash"></i>
          <span className="ml-1">Supprimer</span>
        </button>
      </td>
    </tr>
  )
}
